import { FilePreviewStatus } from '../enums/FilePreviewStatus.enum';

export interface DocumentDto {
    fileId?: string;
    name: string;
    isPermanent: boolean;
    mimeType: string;
    extension: string;
    size: number;
    organizationId: string;
    projectId: string;
    taskId?: string;
    fileMetaDataId?: string;
    externalLinkId?: string;
    expiryDate?: Date;
    id: string;
    createdAt: string;
    previewStatus?: FilePreviewStatus;
    previewUrl?: string;
    externalLinkUrl?: string;
    staticTaskReference?: string;
}
